<!-- eslint-disable no-irregular-whitespace -->
<!-- 合伙人协议 -->
<template>
  <van-dialog
    v-model="show"
    show-cancel-button
    cancel-button-text="不同意并退出"
    :confirm-button-text="`同意并继续${timeZone}`"
    className="protocol"
    :beforeClose="beforeClose"
    @confirm="confirmModal"
    @cancel="cancel"
  >
    <div  class="protocol-content">
      <PromotionAgreement />
    </div>
  </van-dialog>
</template>
<script>
import Cookie from 'js-cookie'
import PromotionAgreement from './promotionAgreement.vue'
export default {
  name: 'protocolModal',
  components: { PromotionAgreement },
  data() {
    return {
      show: false,
      timeLimit: 10
    }
  },
  computed: {
    timeZone() {
      return this.timeLimit > 0 ? `(${this.timeLimit}s)` : ''
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.timeLimit = 10
        this.timer = setInterval(() => {
          --this.timeLimit
          if (this.timeLimit <= 0) {
            clearInterval(this.timer)
          }
        }, 1000)
      }
    }
  },

  methods: {
    // 取消的话 清除cookie
    cancel() {
      clearInterval(this.timer)
      if (Cookie.get('helper_tk')) {
        Cookie.remove('helper_tk')
      }
    },
    confirmModal() {
      if (this.timeLimit <= 0) {
        this.$emit('confirm')
      }
    },
    beforeClose(action, done) {
      if (action === 'confirm' && this.timeLimit > 0) {
        done(false)
      } else {
        done()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.protocol {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  transform: none;
  border-radius: 0;
  box-sizing: border-box;
  padding: 32px 16px;
  background: url(~@/assets/images/agreementBg.png) no-repeat top left;
  background-size: 100% auto;
  background-color: #F3FEFF;
  /deep/.van-dialog__header {
    padding: 0;
  }
  /deep/.van-dialog__content {
    padding: 27px 11px;
    background: #fff;
    border-radius: 12px;
    color: #302b3e;
    height: calc(100% - 32px - 150px);
  }
  .protocol-content {
    height: calc(100vh - 44px - 200px);
    overflow-y: auto;

  }
  /deep/.van-dialog__footer{
    display: flex;
    flex-direction: column-reverse;
    background: transparent;
    margin-top: 40px;
    .van-dialog__confirm{
      height: 40px;
      width: calc(100vw - 110px);
      margin: 0 auto;
      background: #ffb600;
      border-radius: 40px;
      font-size: 16px;
      color: #302b3e;
      line-height: 20px;
      font-weight: 600;
      text-align: center;
      line-height: 40px;
    }
    .van-dialog__cancel{
      text-align: center;
      margin-top: 22px;
      color: #666666;
      font-size: 16px;
      background: transparent;
    }
  }
  /deep/.van-hairline--top {
    &::after {
      border-top-width: 0;
    }
  }
}
</style>
